import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface TransferAirport {
  id: string;
  name: string;
  code: string;
  city: string | null;
  latitude: number | null;
  longitude: number | null;
  is_active: boolean;
  sort_order: number;
}

export const useTransferAirports = () => {
  const [airports, setAirports] = useState<TransferAirport[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAirports();
  }, []);

  const fetchAirports = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('transfer_airports')
        .select('*')
        .eq('is_active', true)
        .order('sort_order');

      if (error) throw error;
      setAirports((data || []) as TransferAirport[]);
    } catch (err) {
      console.error('Error fetching transfer airports:', err);
    } finally {
      setLoading(false);
    }
  };

  return { airports, loading, refetch: fetchAirports };
};
